export default "__VITE_ASSET__1ca6f631__"